export { Caption1Stronger } from './Caption1Stronger';
export { caption1StrongerClassNames } from './useCaption1Stronger.styles';
